import Vue from 'vue'
import VueRouter from 'vue-router'

Vue.use(VueRouter)

const routes = [
  {
    path: '/',
    name: 'Home',
    component: () => import('@/views/home.vue')
  },
  {
    path: '/info-main',
    name: 'InfoMain',
    component: () => import('@/views/infomain.vue')
  },
  {
    path: '/show-info/:id',
    name: 'ShowInfo',
    component: () => import('@/views/showinfo.vue')
  },
  {
    path: '/show-comp/:id',
    name: 'ShowComp',
    component: () => import('@/views/showcomp.vue')
  },
  {
    path: '/search-job',
    name: 'SearchJob',
    component: () => import('@/views/searchjob.vue')
  },
  {
    path: '/search-comp',
    name: 'SearchComp',
    component: () => import('@/views/searchcomp.vue')
  },
  {
    path: '/show-job/:id',
    name: 'ShowJob',
    component: () => import('@/views/showjob.vue')
  },
  {
    path: '/meeting',
    name: 'ShowJob',
    component: () => import('@/views/meeting.vue')
  },
  {
    path: '/show-meet/:id',
    name: 'ShowMeet',
    component: () => import('@/views/showmeet.vue')
  }
]

const router = new VueRouter({
  mode: 'history',
  base: process.env.BASE_URL,
  routes
})

export default router
